import { Params } from "react-router-dom";
import client from "./axios";
import { User } from "../models/User";

const patientsUrl = `${window.__env.BASE_URL}/patients`;

export const Patients = {
    getPatients: (params?: URLSearchParams) => client.get<any>(patientsUrl, { params }),
    getPatient: (id: string) => client.get<User>(`${patientsUrl}/${id}`),
    createPatient: (user: User) => client.post<User>(patientsUrl, user),
    updatePatient: (user: Partial<User>) => client.put<User>(`${patientsUrl}/${user.id}`, user),
    deletePatient: (id: number) => client.delete<User>(`${patientsUrl}/${id}`),
    getPatientSchedule: (patientId: number, from: String, to: String, params: any) => client.get(`${patientsUrl}/${patientId}/schedule/${from}/${to}`, params),
    savePatientSchedule: (patientId: number, params: any) => client.post(`${patientsUrl}/${patientId}/protocols`, params),
    updatePatientSchedule: (patientId: number, protocolInstanceId: number, params: any) => client.put(`${patientsUrl}/${patientId}/protocols/${protocolInstanceId}`, params),
    deletePatientProtocol: (patientId: number, protocolInstanceId: number) => client.delete(`${patientsUrl}/${patientId}/protocols/${protocolInstanceId}`),
    assignDoctor: (patientId: number, doctorId: number) => client.patch(`${patientsUrl}/${patientId}/ref-doctor/${doctorId}`),
    deAssignDoctor: (patientId: number, doctorId: number) => client.delete(`${patientsUrl}/${patientId}/ref-doctor`)
}